import React, {useCallback, useEffect, useState} from 'react';
import {DocumentList} from "../../../components/admin/document/DocumentList";
import {LicenceSettingForm} from "../../../components/admin/document/LicenceSettingForm";
import {BoxTitle} from "../../../components/admin/BoxTitle";
import {ApiQueryParam, ApiService} from "../../../service/ApiService";
import {documentResultCollectionType, documentResultType} from "../../../types/Api/DocumentResultType";
import {documentHydrator} from "../../../models/hydrator/documentHydrator";
import {document} from "../../../models/document";
import {NavLink} from "react-router-dom";
import {scrollTo} from "../../../service/ToolsService";

export const List = () => {
  const [loading, setLoading] = useState(false);
  const [documents, setDocuments] = useState([] as document[]);

  const findDocument = useCallback((): void => {
    const apiFilters: ApiQueryParam = new ApiQueryParam();

    apiFilters.addSort({
      by: 'position',
      direction: 'ASC'
    });
    apiFilters.setCount(-1);

    setLoading(true);
    const result: Promise<documentResultCollectionType> = ApiService.get('/document', apiFilters) as Promise<documentResultCollectionType>;

    result
      .then((r: documentResultCollectionType) => {
        setDocuments(r._embedded.documents.map((document: documentResultType) => {
          return documentHydrator.hydrate(document);
        }));
      })
      .catch(() => {
        alert("Une erreur c'est produite.")
        setDocuments([]);
      })
      .finally(() => {
        setLoading(false);
      })
  }, []);

  useEffect(() => {
    findDocument();
  }, [findDocument]);

  return (
    <>
      <BoxTitle title="Licence"/>
      <LicenceSettingForm/>
      <DocumentList documents={documents} loading={loading} refresh={findDocument}/>
      <div className="mt-3 text-end">
        <NavLink to={`/admin/document/order`} onClick={scrollTo} className="btn btn-sm btn-secondary me-1">
          <i className="fa-solid fa-sort me-1"/> Ordonner
        </NavLink>
        <NavLink to={`/admin/document/add`} onClick={scrollTo} className="btn btn-sm btn-primary me-1">
          <i className="fa-solid fa-plus me-1"/> Ajouter un document
        </NavLink>
      </div>
    </>
  )
}
